<template>
  <div id="underConstruction">
    <div class="page-title">Under Construction</div>
  </div>
</template>

<script>
  export default {
    name: "UnderConstruction",

    mounted() {
      this.$store.state.pageTitleTranslationKey = "under_construction";
      this.$store.state.pageIcon = "/icon/settings.svg";
    }
  }
</script>

<style lang="scss" scoped>
  #underConstruction {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>